import React from 'react'
import { css } from '@emotion/css'
import { AutoVerificationType, VulnerabilityPolicy } from '../index'
import { FormattedMessage } from 'react-intl'

function getTriggerMessages(
  autoVerificationType,
  timeBasedEnabled,
  remediationDays,
  dataE2e
) {
  let autoVerificationMsgId: string | null = null
  if (autoVerificationType === AutoVerificationType.SESSION) {
    autoVerificationMsgId =
      'variable_vulnerabilityPolicyTrigger_sessionBasedDescription'
  } else if (autoVerificationType === AutoVerificationType.ROUTE) {
    autoVerificationMsgId =
      'variable_vulnerabilityPolicyTrigger_routeBasedDescription'
  }

  let standaloneAutoVerificationMsg: any = null
  if (autoVerificationMsgId) {
    standaloneAutoVerificationMsg = (
      <span>
        <FormattedMessage id={autoVerificationMsgId} />
      </span>
    )
  }

  let timeBasedMsg: any = null
  if (timeBasedEnabled) {
    timeBasedMsg = autoVerificationMsgId ? (
      <span>
        <FormattedMessage
          id="variable_vulnerabilityPolicyTrigger_timeBasedDescription"
          values={{ daysDuration: remediationDays }}
        />
        <br />
        <FormattedMessage id={autoVerificationMsgId} />
      </span>
    ) : (
      <span>
        <FormattedMessage
          id="variable_vulnerabilityPolicyTrigger_timeBasedDescription"
          values={{ daysDuration: remediationDays }}
        />
      </span>
    )
  }

  return (
    <div
      data-e2e={dataE2e}
      className={css`
        display: flex;
      `}
    >
      {timeBasedEnabled ? timeBasedMsg : standaloneAutoVerificationMsg}
    </div>
  )
}

export function DescriptionCell({
  dataE2e,
  rowData: { remediationDays, timeBasedEnabled, autoVerificationType }
}: {
  readonly rowData: VulnerabilityPolicy
  readonly dataE2e?: string
}) {
  return getTriggerMessages(
    autoVerificationType,
    timeBasedEnabled,
    remediationDays,
    dataE2e
  )
}
